import { Avatar as HeroAvatar } from "@heroui/react";
import type { ComponentProps } from "react";

const HeroAvatarImage = HeroAvatar.Image;

function AvatarImage({ className, ...props }: ComponentProps<typeof HeroAvatarImage>) {
	const merged = ["object-cover", className].filter(Boolean).join(" ");
	return <HeroAvatarImage {...props} className={merged} />;
}

HeroAvatar.Image = AvatarImage;

export const Avatar = HeroAvatar;
